(function () {
  if (window.snCardSliderReady) return;
  window.snCardSliderReady = true;

  function initSlider(slider) {
    if (slider.dataset.snSliderInit) return;
    slider.dataset.snSliderInit = '1';

    var track = slider.querySelector('[data-sn-track]');
    var dots = slider.querySelectorAll('.sn-card-slider__dot');
    var count = slider.querySelectorAll('.sn-card-slider__slide').length;
    var current = 0;

    if (count <= 1) return;

    function goTo(n) {
      current = ((n % count) + count) % count;
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
      dots.forEach(function (d, i) {
        d.classList.toggle('active', i === current);
      });
    }

    // Buttons zitten als sibling van de slider-link, in card__media
    var cardMedia = slider.closest('.card__media') || slider.parentElement.parentElement;
    var prevBtn = cardMedia.querySelector('.sn-card-slider__btn--prev');
    var nextBtn = cardMedia.querySelector('.sn-card-slider__btn--next');

    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        goTo(current - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        goTo(current + 1);
      });
    }

    // Swipe support
    var touchStartX = 0;
    var touchStartY = 0;

    track.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
    }, { passive: true });

    track.addEventListener('touchend', function (e) {
      var dx = touchStartX - e.changedTouches[0].clientX;
      var dy = touchStartY - e.changedTouches[0].clientY;
      // Only swipe if horizontal movement dominates
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 40) {
        e.preventDefault();
        goTo(dx > 0 ? current + 1 : current - 1);
      }
    }, { passive: true });
  }

  function initAll() {
    document.querySelectorAll('[data-sn-slider]').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
